import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { extend, isObject } from '../utils';
import { resolveContainer } from '../utils/dom/getContainer';
import { lockClick } from './lock-click';
import BaseToast from './Toast';
var defaultOptions = {
  icon: '',
  message: '',
  className: '',
  type: 'info',
  position: 'middle',
  forbidClick: false,
  duration: 2000,
  teleport: function teleport() {
    return document.body;
  }
};
var toastArray = [];
var allowMultiple = false;
var currentOptions = extend({}, defaultOptions); // default options of specific type

var defaultOptionsMap = new Map(); // 同步的销毁

function syncClear() {
  var fn = toastArray.pop();

  while (fn) {
    fn();
    fn = toastArray.pop();
  }
} // 针对 toast 还没弹出来就立刻销毁的情况，将销毁放到下一个 event loop 中，避免销毁失败。


function nextTickClear() {
  setTimeout(syncClear);
} // 可返回用于销毁此弹窗的方法


var Toast = function Toast(p) {
  var props = parseOptions(p);
  var update = {
    config: function config() {},
    clear: function clear() {
      return null;
    }
  };
  var timer = 0;
  var onClose = props.onClose,
      teleport = props.teleport;
  var container = document.createElement('div');
  var bodyContainer = resolveContainer(teleport);
  bodyContainer.appendChild(container);

  var TempToast = function TempToast() {
    var options = _objectSpread({
      duration: 2000
    }, props);

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        visible = _useState2[0],
        setVisible = _useState2[1];

    var _useState3 = useState(_objectSpread({}, options)),
        _useState4 = _slicedToArray(_useState3, 2),
        state = _useState4[0],
        setState = _useState4[1]; // clearDOM after animation


    var internalOnClosed = useCallback(function () {
      if (state.forbidClick) {
        lockClick(false);
      }

      var unmountResult = ReactDOM.unmountComponentAtNode(container);

      if (unmountResult && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    }, [container]); // close with animation

    var destroy = useCallback(function () {
      setVisible(false);
      if (onClose) onClose();
    }, []);
    update.clear = internalOnClosed;
    update.config = useCallback(function (nextState) {
      setState(function (prev) {
        return typeof nextState === 'function' ? _objectSpread(_objectSpread({}, prev), nextState(prev)) : _objectSpread(_objectSpread({}, prev), nextState);
      });
    }, [setState]);
    useEffect(function () {
      setVisible(true);
      if (!allowMultiple) syncClear();
      toastArray.push(internalOnClosed);

      if (state.duration !== 0 && 'duration' in state) {
        timer = window.setTimeout(destroy, +state.duration);
      }

      return function () {
        if (timer !== 0) {
          window.clearTimeout(timer);
        }
      };
    }, []);
    return /*#__PURE__*/React.createElement(BaseToast, _extends({}, state, {
      visible: visible,
      teleport: function teleport() {
        return container;
      },
      onClose: destroy,
      onClosed: internalOnClosed
    }));
  };

  ReactDOM.render( /*#__PURE__*/React.createElement(TempToast, null), container);
  return update;
};

function parseOptions(message) {
  if (isObject(message)) {
    return message;
  }

  return {
    message: message
  };
}

var createMethod = function createMethod(type) {
  return function (options) {
    return Toast(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, currentOptions), defaultOptionsMap.get(type)), parseOptions(options)), {}, {
      type: type
    }));
  };
};

['info', 'loading', 'success', 'fail'].forEach(function (method) {
  Toast[method] = createMethod(method);
});

Toast.allowMultiple = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  allowMultiple = value;
};

Toast.clear = nextTickClear;

function setDefaultOptions(type, options) {
  if (typeof type === 'string') {
    defaultOptionsMap.set(type, options);
  } else {
    extend(currentOptions, type);
  }
}

Toast.setDefaultOptions = setDefaultOptions;

Toast.resetDefaultOptions = function (type) {
  if (typeof type === 'string') {
    defaultOptionsMap.delete(type);
  } else {
    currentOptions = extend({}, defaultOptions);
    defaultOptionsMap.clear();
  }
};

export default Toast;